import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { CareerPlan } from 'src/app/models/career-plans';
import { CareerPlansApiService } from '../api/career-plans-api.service';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CareerPlanHistoryItemResolverService  {

  constructor(private careerPlanApiService: CareerPlansApiService,
              private router: Router) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CareerPlan> {
    const careerPlanId = route.params['careerPlanId'];
    return this.careerPlanApiService.getCareerPlanDetail(careerPlanId).pipe(catchError(() => {
      this.router.navigate(['/']);
      return EMPTY;
    }));
  }
}
